<template>
    <ul>
        <li v-if="timeout === null" class="py-1" v-html="$t('betDialogConfirm.timeoutKickOffText')"></li>
        <li v-else class="py-1" v-html="$t('betDialogConfirm.timeoutText', { timeout: timeoutToText() })"></li>
        <li v-if="isTopUps" class="py-1" v-html="$t('betDialogConfirm.isTopUpsText')"></li>
    </ul>
</template>

<script>
    export default {
        name: 'BetDialogConfirmationInfo',
        props: {
            id: {
                default: '0',
                type: String,
            },
            module: undefined,
            odds: {
                default: undefined,
                type: String,
            },
            timeout: {
                default: undefined,
                type: Number,
            },
            isTopUps: {
                default: false,
                type: Boolean,
            },
        },

        methods: {
            timeoutToText() {
                let isLive = this.betFeedData[this.id].marketId == this.$const.DBALL_MARKET_LIVE;

                if (isLive) {
                    if (this.timeout < 60) {
                        //seconds
                        return this.timeout + ' ' + this.$t('betDialogConfirm.seconds');
                    } else if (this.timeout === 60) {
                        return ' 1' + this.$t('betDialogConfirm.minute');
                    } else if (this.timeout > 60) {
                        return this.timeout / 60 + ' ' + this.$t('betDialogConfirm.minutes');
                    }
                } else {
                    if (this.timeout < 60) {
                        //seconds
                        return this.timeout + ' ' + this.$t('betDialogConfirm.seconds');
                    } else if (this.timeout === 60) {
                        return ' 1' + this.$t('betDialogConfirm.minute');
                    } else if (this.timeout > 60 && this.timeout < 3600) {
                        return this.timeout / 60 + ' ' + this.$t('betDialogConfirm.minutes');
                    } else if (this.timeout === 3600) {
                        return this.timeout / (60 * 60) + ' ' + this.$t('betDialogConfirm.hour');
                    } else if (this.timeout > 3600) {
                        return this.timeout / (60 * 60) + ' ' + this.$t('betDialogConfirm.hours');
                    }
                }
            },
        },

        computed: {
            betFeedData: {
                get() {
                    return this.$store.getters[this.module + '/getBetFeedData'];
                },
                set(value) {
                    this.$store.commit(this.module + '/setBetFeedData', value);
                },
            },
        },
    };
</script>
